import { Box, Typography, styled } from "@mui/material";

export const Head = styled(Box)(({ theme }) => ({ props }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    padding: '48px 96px',
    flexDirection: "column",
    alignItems: 'start',
    gap: '12px',
    [theme.breakpoints.down('lg')]: {
        padding: '24px 48px'
    },
    [theme.breakpoints.down('md')]: {
        flexDirection: "column",
        alignItems: 'start',
        padding: '16px'
    },
    [theme.breakpoints.down('sm')]: {
        flexDirection: "column",
        alignItems: 'start',
        padding: '16px 24px'
    },
}))
export const HeadText = styled(Typography)(({ theme }) => ({ props }) => ({
    fontSize: '32px',
    fontWeight: '700',
    color: '#000',
    lineHeight: '0',
    margin:'0 0 16px',
    [theme.breakpoints.down('md')]: {
        fontSize: '24px',
        margin: '16px 0 16px',

    }
}))
export const ContentSlide = styled(Box)(({ theme }) => ({ props }) => ({
    background: '#F2F2F2',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
    , width: '150px',
    height: '150px',
    borderRadius: '50%',
    [theme.breakpoints.down('md')]: {
        width: '75px',
        height: '75px'
    }, 
}))
export const Slide = styled(Box)(({ theme }) => ({ props }) => ({
    width: "100%", position: 'relative',
    [theme.breakpoints.down('md')]: {
        width: "100%",
        position: 'static',
    }
}))